import { config } from "enviroment.js"
import React, { useEffect, useState } from 'react'
import axios from 'axios'
import { Spin, Button } from 'antd'
import "antd/dist/antd.css"
import 'Pages/Admin/Admin.scss'
import {getCookie} from 'common/utils/auth'
import AdminPageHeader from 'Pages/Admin/AdminPageHeader'
import ItemSection from 'Pages/Admin/Components/ItemSection'
import EditItemModal from 'Pages/Admin/Components/EditItemModal'


const ExperienceDetailView = (props) => {
  const [inventory, setInventory] = useState([])
  const [locks, setLocks] = useState([])
  const [toys, setToys] = useState([])
  const [experienceInfo, setExperienceInfo] = useState()
  const [eventInfo, setEventInfo] = useState()
  const [visible, setVisible] = useState(false)
  const [loading, setLoading] = useState({ status: true, type: 'page' })
  const [error, setError] = useState({ status: false })
  const [activeItem, setActiveItem] = useState()

  useEffect(() => {
    if (props?.match?.params?.id) {
      axios.get(config.raUrl + `/admin/experiences/${props.match.params.id}`, {
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${getCookie('token')}`
        }
      })
        .then((res) => {
          if (res.data.items[1]) setInventory(res.data.items[1])
          if (res.data.items[2]) setLocks(res.data.items[2])
          if (res.data.items[501]) setToys(res.data.items[501])
          setExperienceInfo(res.data.experience)
          setEventInfo(res.data.event)
          setLoading({ status: false })
        }).catch((err) => {
          console.log("error caught: ", err.response)
          let errorMessage = {
            status: true,
            text: 'Ooops!',
            sub: 'Something went wrong.'
          }
          if (err.response.status === 401) {
            errorMessage.text = 'Unauthorized'
            errorMessage.sub = 'You are not authorized to view this page.'
          }
          setError(errorMessage)
          setLoading({ status: false })
        })
    }
  }, [props?.match?.params?.id])

  return (
    <Spin spinning={loading.status} size="large" className={loading.status && loading.type}>
      {error.status
        ? (
          <>
          <div className="error-container">
            <div className="error-text">{error.text}</div>
            <div className="error-sub">{error.sub}</div>
          </div>
          </>
        ) : (
          <>
          <AdminPageHeader
            onBack={() => { window.location.href = '/admin/experiences/' }}
            title={experienceInfo?.name}
            subTitle={experienceInfo?.store}
            extra={eventInfo
              ? [<Button key="1" href={`/host/${eventInfo.xEventId}?auth=${eventInfo.hostPassword}`} target="_blank">View Dashboard</Button>]
              : null
            }
          />
          <ItemSection
            itemType={2}
            items={locks}
            expInfo={experienceInfo}
            setVisible={setVisible}
            setActiveItem={setActiveItem}
            setLoading={setLoading}
            setItems={setLocks}
          />
          <ItemSection
            itemType={1}
            items={inventory}
            expInfo={experienceInfo}
            setVisible={setVisible}
            setActiveItem={setActiveItem}
            setLoading={setLoading}
            setItems={setInventory}
          />
          <EditItemModal
            visible={visible}
            setVisible={setVisible}
            activeItem={activeItem}
            setActiveItem={setActiveItem}
            setInventory={setInventory}
            experienceInfo={experienceInfo}
            setLocks={setLocks}
          />
          </>
        )
      }
      
    </Spin>
  )
}
export default ExperienceDetailView
